import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5da6dd80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-nav" }
const _hoisted_2 = {
  class: "nav nav-tabs",
  id: "nav-tab",
  role: "tablist"
}
const _hoisted_3 = { class: "price" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "¥ ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " /BHU", -1))
const _hoisted_6 = {
  class: "tab-content",
  id: "nav-tabContent"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"row title\" data-v-5da6dd80><div class=\"col-2\" data-v-5da6dd80><span data-v-5da6dd80>计算实例规格</span></div><div class=\"col-4\" data-v-5da6dd80>BHU</div><div class=\"col-6\" data-v-5da6dd80>BHU + 计算实例</div></div><div class=\"row title\" data-v-5da6dd80><div class=\"col-2\" data-v-5da6dd80></div><div class=\"col-4\" data-v-5da6dd80><div data-v-5da6dd80>每小时数量</div><div data-v-5da6dd80>每小时价格</div><div data-v-5da6dd80>包月价格</div></div><div class=\"col-6\" data-v-5da6dd80><div data-v-5da6dd80>每小时价格</div><div data-v-5da6dd80>包月价格</div><div data-v-5da6dd80>包年价格</div><div data-v-5da6dd80>2年价格</div><div data-v-5da6dd80>3年价格</div></div></div>", 2)
const _hoisted_9 = { class: "col-2" }
const _hoisted_10 = { class: "col-4" }
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = { class: "col-2" }
const _hoisted_13 = { class: "col-4" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "col-2" }
const _hoisted_16 = { class: "col-4" }
const _hoisted_17 = { class: "col-6" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "remarks" }, [
  /*#__PURE__*/_createElementVNode("span", null, "BHU（BaiHai Unit）是IDP用于计量和定价的标准化单位，不同计算工作消耗的BHU由计算资源类型、处理数据量等指标决定"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "所有价格单位均为人民币 CNY")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.change(1))),
          class: _normalizeClass(_ctx.check===1? 'nav-link-btn active' : 'nav-link-btn'),
          id: "nav-home-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#nav-home",
          type: "button",
          role: "tab",
          "aria-controls": "nav-home",
          "aria-selected": "true"
        }, "标准版", 2),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.change(2))),
          class: _normalizeClass(_ctx.check===2? 'nav-link-btn active' : 'nav-link-btn'),
          id: "nav-profile-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#nav-profile",
          type: "button",
          role: "tab",
          "aria-controls": "nav-profile",
          "aria-selected": "false"
        }, "高级版", 2),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.change(3))),
          class: _normalizeClass(_ctx.check===3? 'nav-link-btn active' : 'nav-link-btn'),
          "data-bs-toggle": "tab",
          "data-bs-target": "#nav-contact",
          type: "button",
          role: "tab",
          "aria-controls": "nav-contact",
          "aria-selected": "false"
        }, "企业版", 2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(_ctx.check !== 1? (_ctx.check === 2? '0.5' : '1.0') : '0.25'), 1),
        _hoisted_5
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.check === 1? 'tab-pane fade show active' : 'tab-pane fade')
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.standard, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "row price-list",
            key: index
          }, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.detail), 1),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, _toDisplayString(item.bhu), 1),
              _createElementVNode("div", null, _toDisplayString(item.bhuPrice), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.bhuMonthPrice)), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.price)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.monthPrice)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.oneYearPrice)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.twoYearPrice)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.threeYearPrice)), 1)
            ])
          ]))
        }), 128))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.check === 2? 'tab-pane fade show active' : 'tab-pane fade')
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.premium, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "row price-list",
            key: index
          }, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(item.detail), 1),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.bhu)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.bhuPrice)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.bhuMonthPrice)), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.price)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.monthPrice)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.oneYearPrice)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.twoYearPrice)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.threeYearPrice)), 1)
            ])
          ]))
        }), 128))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.check === 3? 'tab-pane fade show active' : 'tab-pane fade')
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ultimate, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "row price-list",
            key: index
          }, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(item.detail), 1),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.bhu)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.bhuPrice)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.bhuMonthPrice)), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.price)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.monthPrice)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.oneYearPrice)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.twoYearPrice)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.useThousandSign(item.threeYearPrice)), 1)
            ])
          ]))
        }), 128))
      ], 2)
    ]),
    _hoisted_18
  ], 64))
}